import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Util, expenseApi } from "../../services";
import { Dialog } from "primereact/dialog";
import "./expenseStyle.css";
import properties from "../../config/environmentProperties";
import { Carousel } from "primereact/carousel";
import { Timeline } from "primereact/timeline";
import { DescLength } from "../../common/util/constants";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import moment from "moment";

const MyExpenses = ({ status, expenseCategory }) => {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState();
  const [userExpenseData, setUserExpenseData] = useState([]);
  const [categoryVisible, setCategoryVisible] = useState(true);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [visible, setVisible] = useState(false);
  const docPath = properties.currentEnvironment.docPath + "expense-documents/";
  const [timeline, setTimeline] = useState(false);
  const [expenseActivityData, setExpenseActivityData] = useState([]);
  const [clickedExpenseCategory, setClickedExpenseCategory] = useState("");
  const [dateRange, setDateRange] = useState(null);
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    getExpenseClaim();
  }, [status]);

  const getExpenseClaim = () => {
    let param = {
      status: status,
    };
    expenseApi.getExpenseClaimByUserId(param).then((resp) => {
      let All = [];
      for (let key in resp.data.data) {
        resp.data.data[key].map((el) => {
          All.push(el);
        });
      }
      setAllData(All);
      const insertingObject = {
        title: "All",
        count: All.length,
        data: All,
      };
      const allData = resp.data.data;
      const updatedOptions = expenseCategory.map((item) => {
        const categoryData = allData[item.title] || [];
        return {
          title: item.title,
          count: categoryData.length,
          data: categoryData,
        };
      });
      updatedOptions.unshift(insertingObject);
      setUserExpenseData(insertingObject.data);
      setValue(updatedOptions[0]);
      setOptions(updatedOptions);
    });
  };

  let events = [];
  expenseActivityData.map((e) => {
    return Util.expenseActivityData(e, events, clickedExpenseCategory);
  });

  const customizedMarker = (item) => {
    return (
      <span
        className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
        style={{ backgroundColor: item.color }}
      >
        <i className={item.icon}></i>
      </span>
    );
  };

  const customizedContent = (item) => {
    return Util.TimelineView(item, clickedExpenseCategory);
  };

  const viewClaimTimeline = (rowData) => {
    setClickedExpenseCategory(rowData.expenseCategory);
    getExpenseActivitiesByClaim(rowData.claimId);
    setTimeline(true);
  };

  const getExpenseActivitiesByClaim = (claimId) => {
    expenseApi.getClaimActivities(claimId).then((resp) => {
      setExpenseActivityData(resp.data.data);
    });
  };

  const myExpenseTimeline = (rowData) => {
    return <Button label="View" onClick={() => viewClaimTimeline(rowData)} />;
  };

  const viewMyExpenseTimeline = (rowData) => {
    return (
      <Dialog
        header="Expense Claim TimeLine"
        maximizable
        visible={timeline}
        onHide={() => setTimeline(false)}
        style={{ overflow: "hidden" }}
      >
        <div className="flex-column" style={{ width: 500, overflow: "hidden" }}>
          <Timeline
            value={events}
            className="customized-timeline"
            marker={customizedMarker}
            content={customizedContent}
          />
        </div>
      </Dialog>
    );
  };

  const myExpenseAction = (rowData) => {
    return (
      <>
        <Button
          icon="pi pi-eye"
          className="p-button p-button-primary p-button-icon-only"
          aria-label="View"
          tooltip="View Details"
          tooltipOptions={{ position: "top" }}
          onClick={() => {
            setCurrentRowData(rowData);
            setVisible(true);
          }}
        />
      </>
    );
  };

  const renderCarouselContent = (rowData) => {
    return (
      <Carousel
        value={rowData?.docs}
        itemTemplate={yourCarouselItemTemplate}
        numVisible={1}
        numScroll={1}
        circular
      />
    );
  };

  const yourCarouselItemTemplate = (doc) => {
    return (
      <>
        <p>{doc.fileName}</p>
        <iframe
          src={docPath + doc.fileName}
          title={`Document ${doc.fileName}`}
          style={{ width: "100%", height: "900px" }}
        />
      </>
    );
  };

  const carouselPopup = () => {
    return (
      <Dialog
        header={"Documents"}
        visible={visible}
        modal
        style={{ width: "1200px", height: "900px" }}
        onHide={() => setVisible(false)}
      >
        {renderCarouselContent(currentRowData)}
      </Dialog>
    );
  };

  const changeClaimTab = (e) => {
    e.target.value.title === "All"
      ? setCategoryVisible(true)
      : setCategoryVisible(false);
    setValue(e.value);
    setUserExpenseData(e.value.data);
  };

  const filterByDateRange = (data, startDate, endDate) => {
    return data.filter((expense) => {
      const expenseDate = moment(expense.date, "YYYY-MM-DD");
      return expenseDate.isBetween(
        moment(startDate),
        moment(endDate),
        "day",
        "[]",
      );
    });
  };

  const handleDateRangeChange = (e) => {
    const selectedDates = e.value;
    setDateRange(selectedDates);
    if (selectedDates && selectedDates[0] && selectedDates[1]) {
      const filtered = filterByDateRange(
        allData,
        selectedDates[0],
        selectedDates[1],
      );
      const insertingObject = {
        title: "All",
        count: filtered.length,
        data: filtered,
      };
      const updatedOptions = expenseCategory.map((item) => {
        const categoryData = filtered.filter(
          (exp) => exp.expenseCategory === item.title,
        );
        return {
          title: item.title,
          count: categoryData.length,
          data: categoryData,
        };
      });
      updatedOptions.unshift(insertingObject);
      setOptions(updatedOptions);
      const current =
        updatedOptions.find((opt) => opt.title === value?.title) ||
        updatedOptions[0];
      setValue(current);
      setUserExpenseData(current.data);
    }
  };

  const resetDateFilter = () => {
    setDateRange(null);
    const insertingObject = {
      title: "All",
      count: allData.length,
      data: allData,
    };
    const updatedOptions = expenseCategory.map((item) => {
      const categoryData = allData.filter(
        (exp) => exp.expenseCategory === item.title,
      );
      return {
        title: item.title,
        count: categoryData.length,
        data: categoryData,
      };
    });
    updatedOptions.unshift(insertingObject);
    setOptions(updatedOptions);
    const current =
      updatedOptions.find((opt) => opt.title === value?.title) ||
      updatedOptions[0];
    setValue(current);
    setUserExpenseData(current.data);
  };

  const statusBodyTemplate = (data) => {
    return (
      <span
        style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}
      >
        {Util.fetchStatus(data.status, data.expenseCategory)}
      </span>
    );
  };

  const myExpenseCategory = () => {
    return (
      <div
        className="mb-2"
        style={{ display: "flex", alignItems: "center", gap: "20px" }}
      >
        <div>
          <label htmlFor="expense-category" style={{ marginRight: "10px" }}>
            <b>Category : </b>
          </label>
          <Dropdown
            value={value}
            options={options}
            onChange={changeClaimTab}
            optionLabel="title"
            placeholder="Select a Category"
            itemTemplate={(option) => (
              <span>
                {option.title} ({option.count})
              </span>
            )}
            style={{ width: "277px" }}
          />
        </div>
        <div>
          <label htmlFor="date-range" style={{ marginRight: "10px" }}>
            <b>Date Range : </b>
          </label>
          <Calendar
            value={dateRange}
            onChange={handleDateRangeChange}
            selectionMode="range"
            readOnlyInput
            placeholder="Select Date Range"
            dateFormat="dd/mm/yy"
            showIcon
            style={{ width: "277px" }}
          />
          <Button
            icon="pi pi-replay"
            rounded
            text
            severity="secondary"
            className="ml-2"
            onClick={resetDateFilter}
            tooltip="Reset Date Filter"
            tooltipOptions={{ position: "top" }}
            disabled={!dateRange}
          />
        </div>
      </div>
    );
  };

  const wrapDescription = (rowData) => {
    const description = rowData.description;
    return (
      <div title={description}>
        {description.length > DescLength.DESCRIPTION
          ? `${description.substring(0, DescLength.DESCRIPTION)}....`
          : description}
      </div>
    );
  };

  const myAllExpenseCategory = () => {
    return (
      <div className="ess-table">
        <DataTable
          key={"id"}
          paginator
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          resizableColumns
          value={userExpenseData}
          columnResizeMode="fit"
          scrollable="horizontal"
          stripedRows
        >
          <Column field="date" header="Date" style={{ minWidth: "1rem" }} />
          <Column
            field="claimId"
            header="ClaimId"
            style={{ minWidth: "1rem" }}
          />
          {categoryVisible && (
            <Column
              field="expenseCategory"
              header="Category"
              style={{ minWidth: "1rem" }}
            />
          )}
          <Column
            field="claimAmount"
            header="ClaimAmount"
            style={{ minWidth: "1rem" }}
            body={(rowData) => Util.renderClaimAmount(rowData)}
          />
          <Column
            field="description"
            header="Description"
            style={{ minWidth: "3rem" }}
            body={wrapDescription}
          />
          <Column
            field="status"
            header="Status"
            style={{ minWidth: "1rem" }}
            body={statusBodyTemplate}
          />
          <Column
            header="Document"
            style={{ minWidth: "1rem" }}
            body={myExpenseAction}
          />
          <Column
            header="Timeline"
            style={{ minWidth: "1rem" }}
            body={myExpenseTimeline}
          />
        </DataTable>
      </div>
    );
  };

  return (
    <div className="ess-page">
      {myExpenseCategory()}
      <hr />
      {myAllExpenseCategory()}
      {carouselPopup()}
      {viewMyExpenseTimeline()}
    </div>
  );
};
export default MyExpenses;
